module.exports = __webpack_public_path__ + "modules/aboutUs/images/news_wx.png?8688c9dc";


//////////////////
// WEBPACK FOOTER
// ./modules/aboutUs/images/news_wx.png
// module id = 130
// module chunks = 0